import { Component, Input, OnInit } from "@angular/core";
import * as _ from "underscore";

import { SharedService } from "../../service/api/shared.service";
import { CAST_INTERFACE } from "../../service/interface/shared.interface";

@Component({
  selector: "app-cast-subcast",
  templateUrl: "./cast-subcast.component.html",
  styleUrls: ["./cast-subcast.component.scss"],
})
export class CastSubcastComponent implements OnInit {
  _data: CAST_INTERFACE;
  editableMode: boolean = false;
  castData: any;
  subCastData: any;

  @Input()
  set data(value) {
    if (value != null || value != undefined) {
      this._data = value;
    }
    if (!_.isEmpty(this._data)) {
      this.editableMode = true;
    }
  }
  get data() {
    return this._data;
  }

  constructor(private service: SharedService) {}

  getCast() {
    this.service.getCast().subscribe((res: any) => {
      this.castData = res;
      if (this.editableMode && this._data.cast != undefined) {
        this.castData.filter((cast) => {
          cast.id === this._data.cast["id"] ? (this._data.cast = cast) : "";
          this.getsubcastWithCast(this._data.cast["id"]);
        });
      }
    });
  }

  onChangeCast() {
    let selectedCastId = this._data.cast["id"];
    this.getsubcastWithCast(selectedCastId);
  }

  getsubcastWithCast(id) {
    this.castData.forEach((element) => {
      if (element.id == id) {
        this.subCastData = element.subcast;
        if (this.editableMode === true) {
          this.subCastData.filter((ctype) => {
            ctype.id === this._data.subcast ? (this._data.subcast = ctype) : "";
          });
        }
      }
    });
  }

  ngOnInit() {
    setTimeout(() => this.getCast(), 500);
  }
}
